<template><div><h1 id="projektumsatz" tabindex="-1"><a class="header-anchor" href="#projektumsatz"><span>Projektumsatz</span></a></h1>
<p>Umsätze pro Jahr — Jahresumsätze pro Projekt</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Zeigt eine Übersicht der Projektumsätze, kumuliert pro Jahr.</p>
<p>Pfad: <code v-pre>Projektfinanzierung → Projekte</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Periode</dt>
<dd>Auswertungsjahr. Hierbei kann es sich um ein Kalenderjahr (z.B. 2008) oder ein Geschäftsjahr (z.B. 2008/2009) handeln</dd>
<dt>P-Ziel brutto</dt>
<dd>Geplantes Projektziel Brutto</dd>
<dt>Vorbesteheneder Ertrag (ehem. Saldovortrag)</dt>
<dd>Bereits realisierter Ertrag, der nicht direkt aus diesem Projekt stammt (wird vom Projektziel abgezogen).</dd>
<dt>Projektziel Netto</dt>
<dd>Berechnet aus [Projektziel] - [Vorbestehender Ertrag]</dd>
<dt>Kollektivmarketing</dt>
<dd>Eingang von Zahlungen auf das Projekt, welche über ein Kollektivmarketing-Ereignis akquiriert wurden. Entscheidend für die Verbuchung der Zahlungen unter Kollektivmarketing ist der Schalter in der Ereignisdefinition, sowie die Verknüpfung des Ereignisses mit dem Projekt. Details siehe <a class="link" href="ft.refdata.ereigknuepfman.html" title="Ereignisse zu Person">Manuelle Ereignisverknüpfung.</a> Nur vereinnahmte Zahlungen werden hier aufsummiert.</dd>
<dt>Individualmarketing</dt>
<dd>Eingang von Zahlungen auf das Projekt, welche über ein Individualmarketing-Ereignis akquiriert wurden. Entscheidend für die Verbuchung der Zahlungen unter Individualmarketing ist der Schalter in der Ereignisdefinition sowie die Verknüpfung des Ereignisses mit dem Projekt. Nur vereinnahmte Zahlungen werden hier aufsummiert.</dd>
<dt>Weitere Quellen</dt>
<dd>Summe der Beträge gemäss Tabelle &quot;Weitere Quellen&quot; (manuell erfasst oder aus Aktionen mit Zuordnung &quot;weitere Quellen&quot;).</dd>
<dt>Einnahmen Total</dt>
<dd>Summe der Werte aus den Feldern [Summe Kollektivmarketing] + [Summe Individualmarketing] + [Summe weitere Quellen]</dd>
<dt>Diff. zum Ziel</dt>
<dd>Berechnet aus [Ertrag] - [Projektziel Netto] -</dd>
<dt>zugesagt</dt>
<dd>Betrag der in den Aktionen festgehaltenen zugesagten Zahlungen. Diese sind noch nicht eingetroffen, werden aber erwartet (Individualmarketing). Wird der Wert nicht durch eine Aktion bebucht, kann er hier manuell geändert werden.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


